import React, { Component, Fragment } from 'react'
import { DealsWidget } from './deal_sheet'
import { Authorization } from 'utils/AuthorizationUtils'
import { DealSheet } from 'containers'
import StyleSheet from 'styles'
import { CenteredContent } from 'containers'
import { colorPalette } from 'styles'
import { Link } from 'react-router-dom'
import {FormattedMessage} from 'react-intl';

export class Dashboard extends Component{

  constructor(props){
    super(props)
    this.state = {

    }
  }

  handleRedirect = path => this.props.history.push(path)

  DealsWidgetSeparator = () => {
    return (
      <div className={styles.DealsWidgetSeparator}>
        <div/>
      </div>
    )
  }

  renderSecondaryAction = (label, path) => {
    return (
      <Link to={`${path}`} className={styles.DealsWidgetAction}><FormattedMessage id={label} /></Link>
    )
  }

  render = () => {
    const { DealsWidgetSeparator } = this
    return (
      <div className={styles.dashboardWrapper}>
        <DealSheet.FeaturedListings/>
        <CenteredContent>
          <div style={{clear: 'both'}} />
          <div className={styles.DealsWidgetList}>
            <div className={styles.dashboardDealsWidget}>
              <DealsWidget name="active" title="dashboard.active.title" widgetFilter={{active: true}} pageSize={2}
                renderer='carousel' carouselSize={2}
                cardProps={{showLabels: true}}
                renderPaging={false}
                secondaryAction={ this.renderSecondaryAction('dashboard.active.view_all', '/deal_sheets/list/active')}/>
            </div>
            {
              (Authorization.investor || Authorization.issuer) &&
              <Fragment>
                <DealsWidgetSeparator/>
                <div className={styles.dashboardDealsWidget}>
                  <DealsWidget name="mine" title="dashboard.mine.title" widgetFilter={{participant_id: Authorization.user.id}} pageSize={3}
                    renderPaging={false}
                    secondaryAction={ this.renderSecondaryAction('dashboard.mine.view_all', '/deal_sheets/list/mine')}/>
                </div>
              </Fragment>
            }
          </div>
        </CenteredContent>
      </div>
    )
  }

}

const styles = StyleSheet({
  dashboardWrapper: {
    width: '100%',
    boxSizing: 'border-box',
    paddingBottom: 75,
  },
  background: {
    maxWidth: 270,
    flex: 1
  },
  content: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  author: {
    flex: 1
  },
  quote: {
    flex: 1
  },
  dashboardDealsWidget: {
    width: '100%',
    float: 'left',
    padding: '20px 0px',
    boxSizing: 'border-box',
  },
  DealsWidgetSeparator: {
    width: '100%',
    float: 'left',
    padding: '20px 0px',
    boxSizing: 'border-box',
    '& div': {
      borderTop: 'solid 1px #e8e8e8'
    }
  },
  DealsWidgetList: {
    marginTop: '76px',
    '@media(max-width: 600px)': {
      marginTop: '26px',
    },
  },
  DealsWidgetAction: {
    color: colorPalette.secondary[1].hex(),
    fontSize: '14px',
    fontWeight: 500
  }
})

export default Dashboard